// extracted by mini-css-extract-plugin
export var addButton = "_dz-0";
export var border = "_dz-8";
export var check = "_dz-h";
export var danger = "_dz-6";
export var dropdownContainer = "_dz-1";
export var editModalBody = "_dz-j";
export var footerContainer = "_dz-i";
export var fullWidth = "_dz-a";
export var hide = "_dz-9";
export var icon = "_dz-3";
export var input = "_dz-7";
export var inputFlex = "_dz-b";
export var inputWrapper = "_dz-c";
export var manualFocus = "_dz-5";
export var optionButton = "_dz-4";
export var pillWrapper = "_dz-e";
export var pointer = "_dz-2";
export var showOverflow = "_dz-f";
export var tagsFlex = "_dz-d";
export var xButton = "_dz-g";